import React from 'react';
import { Fade } from '../../animation/animation';
import styles from './background-image.module.scss';
import { Service } from '../../models/service.model';
import { appConfig } from '../../app.config';

interface BackgroundImageProps {
	service: Service | "selection";
	active: boolean;
	image?: string;
}

export default function BackgroundImage({ service, active, image }: BackgroundImageProps) {
	return (
		<Fade when={active}>
			<div className={styles.backgroundImage} style={{ backgroundImage: `url(${image || getBackgrounImageUrl(service)})` }} />
		</Fade>
	);
}

function getBackgrounImageUrl(service: Service | "selection") {
	const baseUrl = appConfig().assets_host + "/img/dentolo/background/";
	let image_url = baseUrl + service + '.jpg';
	if (service == "selection") image_url = baseUrl + 'veneers.jpg';
	if (/implantation|prosthetics|crowns|rem_wisdom|no_palate|cheap_prosthetics/.test(service)) image_url = baseUrl + 'default.jpg';
	if (/pediatrics|ped_orthodontics/.test(service)) image_url = baseUrl + 'child.jpg';

	return image_url;
}